<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ២.ក
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table</v-icon>តារាង​ ២.គ​ ២.ឃ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <priprestueth
              :data="stu_pre"
              :age_cont="age_cont"
              :title="title[1] + ' ' + cur_acc"
              ctitle="អាយុ<p>(ឆ្នាំ)</p>"
            />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <predisable :data="dis_pre" :title="title[2]" :htext="cp[3]"/>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <priprestueth
              :data="eth_pre"
              :title="title[3]"
              ctitle="ជនជាតិដើមភាគ<p>តិចតាមក្រុមអាយុ</p>"
              :age_cont="age_cont"
            />
            <prelaststu :data="lst_pre" :title="title[4]" :lastAcc="lst_acc" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import pripreStudentEth from "@/components/privateascf/pre/preEthnic.vue";
import preLastStu from "@/components/ascf/pre/preLastStudent.vue";
import preDisable from "@/components/ascf/pre/preDisable.vue";

import { cp } from "@/utils/zdesc/cpre.js"

export default {
  props: [
    "title",
    "age_cont",
    "stu_pre",
    "dis_pre",
    "eth_pre",
    "lst_pre",
    "lst_acc",
    "cur_acc",
  ],
  components: {
    /** Student and Ethnic student are the same Form */
    predisable: preDisable,
    priprestueth: pripreStudentEth,
    prelaststu: preLastStu,
  },
  data() {
    return {
      active_tab: 0,
      cp: cp
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>